<button mat-mini-fab [ngClass]="_appsService.companyColorCode || _appsService.projectColorCode ? 'header-image2' : 'header-image'" class="header-image" (click)="openUserProfile()" style="position: relative;">
  <span class="initials"
             [ngStyle]="{ 'color': _appsService.projectColorCode || _appsService.companyColorCode || 'white' }">
    {{ userInitials }}
  </span>
</button>
<!--<mat-icon style="position: absolute; right: -10px; top: 50%; transform: translateY(-50%); font-size: 16px;">
  arrow_drop_down
</mat-icon>-->


<mat-sidenav #rightSidebar
             mode="push"
             position="end"
             class="shadow-effect"
             style="background-color: #FFFFFF; margin-top: 70px; overflow-x:hidden; height:100vh; z-index:10;"
             [(opened)]="sidenavOpen">
  <div class="menu-content">
    <mat-icon style="color: gray; position: absolute; top: 15px; right: 15px; cursor:pointer" (click)="closeSidebar()">close</mat-icon>
    <div style=" height: 100%;width: 90%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <div class="user-image-container">
        <img src="{{imageUrl}}" alt="User Image" class="user-image" />
      </div>
      <h1 [ngClass]="_appsService.classes" style=" font-weight:400; margin:0 !important">{{userInfos?.firstName + ' ' + userInfos?.lastName}}</h1>
      <p [ngClass]="_appsService.classes" style="font-weight: 300; margin:0 !important">{{'basarsoftTech' | localize }}</p>

      <!-- Horizontal Button Container -->
      <div class="button-container">
        <a [ngClass]="_appsService.classes" style="margin-right:10px; color: #00A1FF !important; text-decoration: underline; cursor: pointer; "  
           (click)="openNewPasswordSidebar()">
          {{ 'forgot' | localize }}
        </a>
        <a *ngIf="_appsService.userInfos.roleId != roleEnums.Supervisor" [ngClass]="_appsService.classes"  (click)="managementPanel()" style="color: #00A1FF; text-decoration: underline; cursor: pointer;" >{{'managementPanel' | localize }}</a>
      </div>
      
      <!-- KVKK Link - Ortalı -->
      <div style="width: 100%; display: flex; justify-content: center; margin-top: 12px;">
        <a [ngClass]="_appsService.classes" style="color: #00A1FF; font-weight:500; font-size:medium; text-align:center; cursor:pointer; text-decoration: underline;" (click)="openKvkkModal()">
          {{'securityContracts' | localize}}
        </a>
      </div>

      <hr class="barely-visible-hr">
      <!-- Vertical Dropdowns -->
      <div class="dropdowns-container">
        <ng-container *ngIf="userInfos?.roleId == roleEnums.Admin || userInfos?.roleId == roleEnums.SuperAdmin">
          <mat-label [ngClass]="_appsService.classes" style="text-align: start;">{{'company' | localize}}</mat-label>

          <mat-form-field class="dropdown" style="margin-top:5px; border:1px #CCCCCC solid; border-radius:6px;">
            <mat-select [ngClass]="_appsService.classes" class="user-profile-custom-select" [(ngModel)]="selectedCompanyId" (selectionChange)="onSelectedCompany($event.value)" [disabled]="isInputActive" (closed)="onSelectClosed()">

              <div style="position: relative;">
                <mat-form-field [ngClass]="_appsService.classes" style="width: 100%; padding-left: 10px; padding-bottom: 10px; padding-right: 10px; cursor:pointer">
                  <input matInput
                         [ngClass]="_appsService.classes"
                         placeholder="Arama"
                         (input)="onKey($event)"
                         (focus)="isInputActive = true"
                         (blur)="isInputActive = false"
                         [(ngModel)]="searchCompany" />
                  <mat-icon matSuffix
                            style="position: absolute; right: 8px; color: black; pointer-events: none;">
                    search
                  </mat-icon>
                </mat-form-field>
              </div>

              <mat-option [ngClass]="_appsService.classes" *ngFor="let company of _appsService.filterCompanies" [value]="company.id">
                {{ company.companyName }}
              </mat-option>
            </mat-select>
            <mat-icon style="color: #888888;">
              {{'expand_more'}}
            </mat-icon>
          </mat-form-field>
        </ng-container>





        <mat-label [ngClass]="_appsService.classes" style="text-align: start; margin-top: 20px;">{{'appLanguage' | localize }}</mat-label>
        <mat-form-field [ngClass]="_appsService.classes" class="dropdown" style="margin-top:5px; margin-bottom:10px; border:1px #CCCCCC solid; border-radius:6px;">
          <mat-select [ngClass]="_appsService.classes" class="user-profile-custom-select" [(ngModel)]="languageValue" (selectionChange)="change($event.value)">
            <mat-option [ngClass]="_appsService.classes" *ngFor="let language of languages" [value]="language.value">
              {{language.viewValue }}
            </mat-option>
          </mat-select>

          <mat-icon style="color: #888888;">
            {{'expand_more'}}
          </mat-icon>
        </mat-form-field>

        <mat-label [ngClass]="_appsService.classes" style="text-align: start; margin-top: 16px;"></mat-label>
      <!--   <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin-top: 8px; margin-bottom: 8px;">
          <span [ngClass]="_appsService.classes" style="font-size: 14px;">Tutorial tekrarlanabilir</span>
          <mat-slide-toggle [ngClass]="_appsService.classes" [checked]="tutorialRepeatable" (change)="onTutorialRepeatableChange($event.checked)"></mat-slide-toggle>
        </div> -->
        <div *ngIf="_appsService.userInfos?.roleId == roleEnums.CompanyAdmin" style="width: 100%; display: flex; justify-content: center; align-items: center; margin-bottom: 12px;">
          <span [ngClass]="_appsService.classes" style="font-size: 14px; margin-right: 10px;">Tutorial Intro</span>
          <mat-slide-toggle [ngClass]="_appsService.classes" [checked]="introTourRepeatable" (change)="onIntroTourRepeatableChange($event.checked)"></mat-slide-toggle>
        </div>
      </div>
      <!--<div style="width: 100%; display: flex; justify-content: space-between; margin-bottom: 10px; font-size: large; align-items: center;">
        {{ 'interfaceTheme' | localize }}
        <mat-slide-toggle #darkModeSwitch
                          [checked]="isDarkMode"
                          (change)="toggleTheme($event.checked)">
        </mat-slide-toggle>

      </div>-->

    <div style=" width: 100%; height: 100%; display: flex; justify-content: center; flex-direction: column; padding-left: 0px; padding-right: 0px;">
      <a target="_blank"
         [href]="env.docusaurusUrl + '/docusaurus/'"
         class="user-guide-button white-button">
        <mat-icon class="icon">insert_drive_file</mat-icon>
        <span class="text" [ngClass]="_appsService.classes">
          {{ 'userManuel' | localize }}
        </span>
      </a>

      <a [ngClass]="_appsService.classes" style="color: #00A1FF; font-weight:500; font-size:medium; text-align:center; cursor:pointer" target="_blank" href="assets/UserManuel/Teamer-Kullanim-Klavuzu.pdf">
        {{'downloadUserManuelPdf' | localize}}
      </a>

      <button mat-button
              [ngClass]="_appsService.classes"
              class="user-guide-button blue-button"
              style="color:white; font-size:12.5px"
              (click)="openVideoPlayer()">
        {{ 'watchTutorialAgain' | localize }}
      </button>
      <a [ngClass]="_appsService.classes" style="text-decoration: underline; color: red; cursor: pointer; text-align: center;" (click)="signOutEmit()">{{'logout' | localize}}</a>
      <!--<button (click)="signOutEmit()" mat-button class="logout-button">{{'logout' | localize}}</button>-->
    </div>
    </div>


  </div>
</mat-sidenav>


<mat-sidenav #rightSidebarNewPassword
             mode="push"
             position="end"
             class="shadow-effect new-password-container"
             style="background-color: #FFFFFF; margin-top: 70px; overflow-x:hidden; height:100vh; z-index:10;"
             [(opened)]="sidenavOpenPassword" [ngClass]="this._appsService.classes">
  <div class="menu-content">
    <mat-icon style="color: gray; position: absolute; top: 15px; right: 15px; cursor:pointer" (click)="closeSidebarPwd()">close</mat-icon>
    <ng-container *ngIf="sidenavOpenPassword">
      <app-user-new-password (closeRequest)="closeSidebarPwd()" style="width:100%"></app-user-new-password>
    </ng-container>
  </div>
</mat-sidenav>
